<div class="pages-top">
    <div class="avatar-wrap">
        <div class="avatar">

        </div>
    </div>



    <div class="msg-head-wrap">

    </div>
</div>
<div class="page-mid">
    
</div>


// WEBPACK FOOTER //
// ./src/app/shared/layouts/pages-top/pages-top.component.html